<script>
export default {
    name: 'IconLinkedinLight',
}
</script>
<template>
    <svg class="base-icon icon-linkedin-light" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><g clip-path="url(#a)"><path fill="currentColor"  fill-rule="evenodd" d="M31.086 22.126c3.353-3.427 7.72-5.669 12.8-5.669A20.115 20.115 0 0 1 64 36.571V64h-7.314V36.571a12.8 12.8 0 0 0-25.6 0V64H23.77V18.286h7.315v3.84ZM5.486 10.97A5.486 5.486 0 1 1 5.486 0a5.486 5.486 0 0 1 0 10.971Zm-3.657 7.315h7.314V64H1.829V18.286Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath></defs></svg>
</template>